import consumer from "./consumer";

let assistantChannel = null;

function connectToAssistantChannel(thread_id, callback_fn) {
  if (assistantChannel) return;

  assistantChannel = consumer.subscriptions.create(
    { channel: "AssistantChannel", thread_id: thread_id.toString()},
    {
      connected() {
        console.log(`Connected`);
      },

      disconnected() {
        console.log("Disconnected");
      },

      received(data) {
        console.log("Received:", data);
        if (typeof callback_fn === 'function') {
          callback_fn(data);
        }
      },

      speak(message) {
        this.perform("speak", { message: message, thread_id: thread_id });
      }
    }
  );

  window.assistantChannel = assistantChannel; 
}

function disconnectFromAssistantChannel() {
  if (assistantChannel) {
    consumer.subscriptions.remove(assistantChannel);
    assistantChannel = null;
    window.assistantChannel = assistantChannel
  }
}

window.connectToAssistantChannel = connectToAssistantChannel;
window.disconnectFromAssistantChannel = disconnectFromAssistantChannel;




